<script setup>
import CustomModal from "@/components/CustomModal/CustomModal.vue";
import CustomButton from "@/components/Button/Button.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const paymentMethods = ref(
    [
        {
            id: 1,
            number: '1234',
            date: '12/23'
        },
        {
            id: 2,
            number: '5678',
            date: '12/23'
        },
        {
            id: 3,
            number: '9101',
            date: '12/23'
        }
    ]
);
const showAddPaymentMethodModal = ref(false);
const showDeleteModal = ref(false);

const { t } = useI18n();  // Use the i18n instance
</script>

<template>
    <div class="flex flex-col gap-8 py-12">
        <div v-if="paymentMethods.length === 0"
            class="flex justify-center items-center h-full gap-5 min-h-[400px] alignBoxClass">
            <div class="flex flex-col bg-background-light boxClass justify-between rounded-8xl p-5 pr-16">
                <div>
                    <img src="@/assets/icons/svg/Luggage_40x40.svg" alt="Suitcase">
                </div>
                <div class=" responsive-body-large font-semibold">{{ t('payment.youDontHavePaymentMethods') }}</div>
            </div>
            <div @click="showAddPaymentMethodModal = true"
                class="flex flex-col bg-primary-blue text-white justify-center items-center rounded-8xl p-12 gap-1 cursor-pointer boxClass"
                type="primary">
                <img src="@/assets/icons/svg/Add_24x24_white.svg" alt="Plus" width="44" />
                <div class=" responsive-body-large font-semibold text-center">{{ t('payment.addPaymentMethod') }}</div>
            </div>
        </div>
        <div v-else-if="paymentMethods.length !== 0" class="flex flex-col py-5 gap-3">
            <div class="flex flex-row CardsFlexDirection gap-4">
                <div v-for="methods in paymentMethods" :key="methods.id">
                    <div
                        class="flex flex-col gap-8 min-w-[320px] bg-gradient-to-r from-white to-gradients-aliceBlue py-6 px-5 rounded-12xl Card">
                        <div class="flex justify-between align-center">
                            <img src="/assets/images/visa.png" alt="Visa" class="h-5">
                            <ElDropdown trigger="click" placement="bottom">
                                <img src="@/assets/icons/svg/Menu dots_16x16.svg">
                                <template #dropdown>
                                    <ElDropdownMenu>
                                        <ElDropdownItem class="text-black flex align-center gap-2"
                                            @click="showDeleteModal = true">
                                            <img src="/assets/icons/svg/Delete_24x24.svg" />
                                            {{ t('payment.delete') }}
                                        </ElDropdownItem>
                                    </ElDropdownMenu>
                                </template>
                            </ElDropdown>
                        </div>
                        <div>
                            <div class="responsive-title-6 font-semibold">{{ t('payment.visaCard', { number: methods.number })
                                }}</div>
                            <div class="text-sm">{{ t('payment.expiration', { date: methods.date }) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-5">
                <CustomButton type="black" class="self-start  responsive-body-medium w-fit h-8" :rounded="true"
                    @click="showAddPaymentMethodModal = true">{{ t('payment.addPaymentMethod') }}
                </CustomButton>
            </div>
        </div>
    </div>
    <CustomModal :show="showAddPaymentMethodModal" classes="w-1/6">
        <div class="flex flex-col p-6">
            <div class="cursor-pointer self-end " type="default" @click="showAddPaymentMethodModal = false">
                <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
            </div>
            <div class="flex flex-col gap-2 px-9 py-7.5">
                <div class="flex flex-col gap-6">
                    <div class=" responsive-body-large font-semibold">{{ t('payment.addPaymentMethodTitle') }}</div>
                    <div>
                        <div class="flex justify-start space-x-4 mb-4">
                            <!-- Assuming you have the payment methods images stored in your public directory -->
                            <img src="/assets/images/mastercard.png" alt="Mastercard" class="h-6 creditCards">
                            <img src="/assets/images/visa.png" alt="Visa" class="h-6 creditCards">
                            <img src="/assets/images/american_express.png" alt="American Express"
                                class="h-6 creditCards">
                        </div>
                    </div>
                </div>
                <div class="flex flex-col">
                    <VTextField :label="t('payment.nameOnCard')" type="name" variant="underlined"></VTextField>
                    <VTextField :label="t('payment.cardNumber')" type="card" variant="underlined"></VTextField>
                    <div>
                        <VTextField :label="t('payment.dateOfExpiry')" type="date" variant="underlined"></VTextField>
                        <VTextField :label="t('payment.cvv')" type="number" variant="underlined"></VTextField>
                    </div>
                </div>
                <div class="flex justify-between align-center">
                    <CustomButton type="black" class="self-start  responsive-body-medium w-25 h-13" :rounded="true"
                        @click="onBook">{{ t('payment.done') }}
                    </CustomButton>
                    <div class="text-semibold  responsive-body-small underline">{{ t('payment.cancel') }}</div>
                </div>
                <div>
                    <div class="flex gap-2 max-w-74 min-w-[250px]">
                        <img src="/assets/images/secure.svg" alt="image" />
                        <div class="flex flex-column">
                            <span class=" responsive-body-small font-bold">{{ t('payment.securePayment') }}</span>
                            <span class=" responsive-body-small semibold color-bw-grey">{{ t('payment.bookWithConfidence')
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </CustomModal>
    <CustomModal :show="showDeleteModal">
        <div class="flex flex-col p-6 max-w-[400px]">
            <div class="cursor-pointer self-end " type="default" @click="showDeleteModal = false">
                <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18" />
            </div>
            <div class="flex flex-col gap-2 px-6 py-7.5 max-w-[400px]">
                <div class=" responsive-body-large font-semibold">{{ t('payment.deletePaymentMethod') }}</div>
                <div class="text-sm">{{ t('payment.areYouSureDelete') }}</div>
                <div class="flex align-center">
                    <CustomButton type="black" class="self-start
                         responsive-body-medium w-25 h-13" :rounded="true" @click="onBook">{{ t('payment.delete') }}
                    </CustomButton>
                    <CustomButton type="outline-black" class="self-start
                         responsive-body-medium w-25 h-13" :rounded="true" @click="onBook">{{ t('payment.cancel') }}
                    </CustomButton>
                </div>
            </div>
        </div>
    </CustomModal>

</template>
<style scoped>
.boxClass {
  min-width: 200px;
  max-width: 220px;
  min-height: 240px;
  max-height: 260px;
}
:deep(.v-field__field) {
  min-width: 330px ;
}

@media (max-width: 768px) {
  .Card{
    min-width: 300px;
    width:90vw;
  }
  .CardsFlexDirection{
    flex-direction: column;
    flex-wrap:wrap;
    justify-content:center;
    gap: 20px;
  }
  .boxClass {
    min-width: 120px;
    max-width: 150px;
    min-height: 170px;
    max-height: 190px;
  }
  .alignBoxClass{
    align-items: start;
    min-height: unset;
    height: unset;
  }
  .pr-16{
    padding-right: 0px !important;
  }
  .boxClass div {
    font-size:16px;
  }
  :deep(.v-field__field) {
    min-width: 330px ;
  }
  .creditCards{
    height: 28px;
  }
}
</style>